import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MunkatarsakService } from 'app/main/pages/torzsek/services/munkatarsak.service';

@Component({
  selector: 'app-basic-card',
  templateUrl: './card-basic.component.html',
  styleUrls: ['./card-basic.component.scss'],
})
export class CardBasicComponent implements OnInit {
  @Input() height: string = 'calc(100vh - 183px)';
  @Input() bodyClass?: string;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  // public
  public contentHeader: object;

  constructor(private munkatarsakService: MunkatarsakService) {}

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Basic Card',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/',
          },
          {
            name: 'Card',
            isLink: true,
            link: '/',
          },
          {
            name: 'Basic Card',
            isLink: false,
          },
        ],
      },
    };

    this.munkatarsakService.scrollToTop.subscribe(resp => {
      if (this.scrollContainer) {
        this.scrollContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
      }
    })
  }
}
